import React from "react";
import Management from "./Management";
import CreateAdminRole from "./create_roles/CreateAdminRole";

const Manage: React.FC = ({}) => {
  return (
    <section>
      <section className="mb-4">
        <CreateAdminRole />
      </section>
      <section className="bg-white rounded-md flex flex-col gap-4 p-4">
        <Management />
      </section>
    </section>
  );
};

export default Manage;
